import forOwn from 'lodash/forOwn';
import isEmpty from 'lodash/isEmpty';
import {mapGetters} from "vuex";

export default {
    props: {
        'initSelected': {
            default: false,
            type: Boolean
        },
        'proxyUrl': {
            type: String
        },
    },


    computed: {
        methodSelected: function () {
            return this.paymentMethod === this
        },
        ...mapGetters({
            paymentMethod: "order/paymentMethod",
            order: "order/order",
            invoiceDetails: "order/invoiceDetails",
            captchaResponse: "ui/recaptcha/response",
            getCaptchaComponent: "ui/recaptcha/getCaptchaComponent"
        }),
        canBePaid: function () {
            return this.isActive;
        },
        isActive: function () {
            return true;
        },
        enabledInvoicing() {
            // get value from parent <payment-method> component
            return this.$parent.enabledInvoicing;
        },
        showInvoiceFormLink() {
            return this.methodSelected && this.order.invoiceEnabled && this.enabledInvoicing;
        },
    },
    methods: {
        preparePayment() {
            return new Promise((resolve, reject) => {
                resolve();
            });
        },
        select() {
            this.$store.dispatch("order/setPaymentMethod", this).then()
        },
        addAdditionalFields(data) {
            return data;
        },
        onShowInvoiceForm() {
            this.$root.$emit('showInvoiceForm');
        },
        async pay() {
            if (!this.canBePaid) {
                return false;
            }
            return this.preparePayment().then(async () => {
            if(this.invoiceDetails) {
                if(!this.order.$refs.invoiceForm.validate()) {
                    this.order.$refs.invoiceForm.scrollToForm();
                    return false;
                }
            }

                await this.$store.dispatch("ui/loader/show");
                let data = {
                'orderId': this.order.orderId,
                'userId': this.order.userId,
                }
                data = this.addAdditionalFields(data)
                if (this.captchaResponse !== null) {
                    data['h-captcha-response'] = this.captchaResponse;
                    data['NEW_CAPTCHA_SITE_KEY'] = this.getCaptchaComponent.sitekey;
            }

            if(this.invoiceDetails) {
                data['invoiceDetails'] = this.invoiceDetails;
            }

            try {
                const response = await $http({
                    method: 'post',
                    headers: {
                        'X-CSRFToken': this.$cookies.get('csrftoken'),
                    },
                    data,
                    url: this.proxyUrl,
                });
                await this.payResponseHandler(response);
            } catch (error) {
                    console.log(error);
                await this.payErrorHandler(error);
            }
            }).catch(this.catchResponseHandler);
        },
        async catchResponseHandler(){
        },

        async payResponseHandler(response) {
            if (response.status === 200) {
                if (response.data.success === "OK") {
                    if (response.data.redirect) {
                        document.location = response.data.redirect;
                    } else if (response.data.data) {
                        document.location = response.data.data;
                    } else {
                        await this.$store.dispatch("ui/loader/hide");
                        this.show_errors(null, response.data.error_message || gettext("System error. Please try again later"))
                    }
                } else {
                    await this.$store.dispatch("ui/loader/hide");
                    this.show_errors(null, response.data.error_message || gettext("System error. Please try again later"))
                }
            } else {
                await this.$store.dispatch("ui/loader/hide");
                console.error(response);
            }
        },

        async payErrorHandler(error) {
            const response = error.response;
            let skipErrorLightbox = false;
            if (response) {
                if (response.status === 400) {
                    if(response.data.redirect) {
                        window.location.href = response.data.redirect;
                        return;
                    }
                    if(!isEmpty(response.data.errorFields)) {
                        forOwn(response.data.errorFields, (value, key) => {
                            this.$store.dispatch("order/addFormError", {[key]: value});
                            skipErrorLightbox = true;
                        });
                    }
                }
                if (response.status === 404) {
                    window.location.href = this.order.initUrlNotFound;
                    return;
                }
            }
            this.$store.dispatch("ui/loader/hide").then();
            if(!skipErrorLightbox) {
                this.show_errors();
            }
        },

        show_errors(title = null, body = null) {
            this.$store.dispatch("ui/loader/hide").then();
            this.$store.dispatch("ui/lightbox/show", {
                title: title || gettext("Payment error"),
                body: body || gettext("System error. Please try again later"),
            }).then();
        }
    },
    mounted() {
        if (this.initSelected) {
              this.select()
        } else {
            // this.$parent.$nextTick().then(() => {
            //     this.$parent.selectFirst()
            // })
        }
    }
}